<template>
  <v-layout>
    <v-flex :class="choicesStyles" grow>
      <slot name="choices" />
    </v-flex>
    <v-flex justify-center align-self-center shrink>
      <v-layout column>
        <v-btn :disabled="disabledStack" @click="$emit('stack')" icon large>
          <v-icon x-large>arrow_right</v-icon>
        </v-btn>
        <v-btn :disabled="disabledUnstack" @click="$emit('unstack')" icon large>
          <v-icon x-large>arrow_left</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex :class="stackStyles" grow>
      <slot name="stack">
        <v-subheader>{{ stackLabel }}</v-subheader>
        <div
          v-for="item in stackedItems"
          :key="getValue(item)"
          @click="$emit('select', item)"
        >
          <slot v-bind="{ item, isSelected: isSelected(item) }" name="item">
            <div :class="['pa-1', { 'blue lighten-4': isSelected(item) }]">
              {{ getText(item) }}
            </div>
          </slot>
        </div>
      </slot>
    </v-flex>
  </v-layout>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppStackSelector',
  props: {
    stackedItems: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemText: {
      type: String,
      default: 'name',
    },
    stackLabel: {
      type: String,
      default: '',
    },
    choicesWidth: {
      type: Number,
      default: 300,
    },
    stackWidth: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    disabledStack: Boolean,
    disabledUnstack: Boolean,
  },
  computed: {
    choicesStyles() {
      return css`
        flex-basis: ${this.choicesWidth}px !important;
        height: ${this.height}px;
        overflow-y: scroll;
      `
    },
    stackStyles() {
      return css`
        flex-basis: ${this.stackWidth}px !important;
        height: ${this.height}px;
        overflow-y: scroll;
      `
    },
  },
  methods: {
    getValue(item) {
      return item[this.itemValue]
    },
    getText(item) {
      return item[this.itemText]
    },
    isSelected(item) {
      const value = this.getValue(item)
      return this.selectedItems.find(i => this.getValue(i) === value) != null
    },
    toggleItem(item) {
      if (this.isSelected(item)) {
        this.$emit('deselect', item)
      } else {
        this.$emit('select', item)
      }
    },
  },
}
</script>
